import Tool, { type ToolButtonComponent } from './Tool';
import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import ToolButton from '../toolbars/ToolButton';
import styles from '../styles.module.css';
import classNames from 'classnames';
import WhiteboardController from '../controllers/WhiteboardController';
import Shortcut from '../utils/Shortcut';

const PanButton: ToolButtonComponent = ApplicationView(() => {
  const controller = useController(WhiteboardController);
  const { currentStylus, stylusLocked } = controller.state;
  const isCurrentStylus = controller.stylusPan.isCurrentStylus(currentStylus);

  return (
    <ToolButton
      className={classNames({
        [styles.toolButtonActive]: isCurrentStylus,
        [styles.toolButtonLocked]: isCurrentStylus && stylusLocked,
      })}
      onClick={() => controller.actionApplyTool(ToolPan)}
      tool={ToolPan}
    >
      <aha-icon icon='fa-regular fa-hand' />
    </ToolButton>
  );
});

class ToolPan extends Tool {
  static toolName = 'Pan';
  static shortcut = new Shortcut('Space');

  static action({ controller }) {
    controller.actionSetStylusMenu(null);
    if (controller.isStylusLocked(controller.stylusPan)) {
      controller.actionUnlockStylus();
      controller.actionResetStylus();
    } else {
      controller.actionSetStylus(controller.stylusPan);
      controller.actionLockStylus();
    }
  }

  static enabled() {
    return true;
  }

  static buttonComponent() {
    return PanButton;
  }
}

export default ToolPan;
